interface RecordingsIconProps {
  className?: string;
  width?: number;
  height?: number;
}

export function RecordingsIcon({ className, width = 48, height = 49 }: RecordingsIconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M24 38C27.5804 38 31.0142 36.5777 33.5459 34.0459C36.0777 31.5142 37.5 28.0804 37.5 24.5C37.5 20.9196 36.0777 17.4858 33.5459 14.9541C31.0142 12.4223 27.5804 11 24 11C20.4196 11 16.9858 12.4223 14.4541 14.9541C11.9223 17.4858 10.5 20.9196 10.5 24.5C10.5 28.0804 11.9223 31.5142 14.4541 34.0459C16.9858 36.5777 20.4196 38 24 38ZM24 3.5C12.402 3.5 3 12.902 3 24.5C3 36.098 12.402 45.5 24 45.5C35.598 45.5 45 36.098 45 24.5C45 12.902 35.598 3.5 24 3.5ZM6 24.5C6 14.5595 14.0595 6.5 24 6.5C33.9405 6.5 42 14.5595 42 24.5C42 34.4405 33.9405 42.5 24 42.5C14.0595 42.5 6 34.4405 6 24.5Z" fill="currentColor" />
    </svg>
  );
}
